import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LanguageChangeService {
  // Observable string sources
  private languageChanged = new Subject<string>();
  // Observable string streams
  languageChanged$ = this.languageChanged.asObservable();
  // Service message commands
  changeLanguage(lang: string) {
    this.languageChanged.next(lang);
  }
}
